import { graphql } from 'react-relay';

const UpdateBulkAttachmentOrderMutation = graphql`
    mutation UpdateBulkAttachmentOrderMutation($input: AttachmentTypeInput!) {
        updateBulkAttachmentOrder(input: $input) {
            id
            ...AttachmentFragment
        }
    }
`;

export default UpdateBulkAttachmentOrderMutation;
